import { render, staticRenderFns } from "./CutoffMonitor.vue?vue&type=template&id=4a7d72e8&scoped=true"
import script from "./CutoffMonitor.vue?vue&type=script&lang=js"
export * from "./CutoffMonitor.vue?vue&type=script&lang=js"
import style0 from "./CutoffMonitor.vue?vue&type=style&index=0&id=4a7d72e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d72e8",
  null
  
)

export default component.exports